import React, { useRef, useState, useEffect } from "react";
import PrivateAuthState from "./game/PrivateAuthState";
import { GameConfigContext, GamePlayerContext, LocalPlayerContext, PlayerSelectionContext, SceneContext } from "./game/context/game-context";
// import Grass from "./game/shader/grass";
import './plugin/fontawesome';

//  css load
import "./css/style.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./css/joystick.css";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SceneHandler } from "./game/scene-handler";
import { AnimationControl } from "./game/component/html-component/animation-control";
import ActivationLink from "./game/component/html-component/auth/activation-link";
import Game from "./game/Game";
import PasswordReset from "./game/component/html-component/auth/password-reset";
import RequestActivationLink from "./game/component/html-component/auth/request-activation-link";

function App() {

    const sceneID = useRef('ut');
    const [listAvatar, setListAvatar] = useState([]);

    return (<>

        <BrowserRouter>
            <div className="App">
                <AnimationControl />
                <Routes>

                    <Route path="/" element={<Game sceneID={sceneID} setListAvatar={setListAvatar} listAvatar={listAvatar} />} />
                    <Route path="/auth/activate/:activationCode" element={<ActivationLink />} />
                    <Route path="/auth/reset_password/:passwordCode" element={<PasswordReset />} />
                    <Route path="/auth/request_activation_link/:activationCode" element={<RequestActivationLink />} />
                    <Route path="/:sceneid" element={<>
                        <SceneHandler sceneID={sceneID} setListAvatar={setListAvatar} />
                    </>
                    } />
                    {/* <Route path="/animaverse/:sceneid" element={<Child sceneID={sceneID} />} /> */}
                </Routes>

                {/* <Suspense fallback={loading}> */}

            </div>
        </BrowserRouter>
    </>
    )
}
export default App;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
